var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonKinesisDataStreams32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Amazon-Kinesis-Data-Streams_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D27A8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A166FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Amazon-Kinesis-Data-Streams_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/Analytics",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/Amazon-Kinesis-Data-Streams",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4,9.706 L3,9.706 C3,13.238 7.767,15.479 17.172,16.413 C7.767,17.345 3,19.587 3,23.119 L4,23.119 C4,20.801 7.233,16.913 28.888,16.913 L28.888,15.913 C7.233,15.913 4,12.024 4,9.706 L4,9.706 Z M6.874,5.874 L5.874,5.874 C5.874,10.385 8.608,14.997 28.888,14.997 L28.888,13.997 C9.489,13.997 6.874,9.891 6.874,5.874 L6.874,5.874 Z M9.748,3 L8.748,3 C8.748,8.101 10.303,13.081 28.888,13.081 L28.888,12.081 C9.748,12.081 9.748,6.616 9.748,3 L9.748,3 Z M21.987,26.871 L22.891,26.871 L22.891,25.797 L21.987,25.797 L21.987,26.871 Z M23.891,25.297 L23.891,27.371 C23.891,27.647 23.667,27.871 23.391,27.871 L21.486,27.871 C21.21,27.871 20.986,27.647 20.986,27.371 L20.986,25.297 C20.986,25.02 21.21,24.797 21.486,24.797 L23.391,24.797 C23.667,24.797 23.891,25.02 23.891,25.297 L23.891,25.297 Z M21.011,23.893 L22.914,23.893 L22.914,22.893 L21.011,22.893 L21.011,23.893 Z M24.842,21.941 L25.863,21.941 L25.863,20.949 L24.842,20.949 L24.842,21.941 Z M27.739,23.836 C27.739,22.819 27.41,21.881 26.863,21.108 L26.863,22.441 C26.863,22.717 26.64,22.941 26.363,22.941 L24.342,22.941 C24.065,22.941 23.842,22.717 23.842,22.441 L23.842,20.449 C23.842,20.172 24.065,19.949 24.342,19.949 L25.699,19.949 C24.932,19.413 24.002,19.093 22.996,19.093 C21.453,19.093 20.094,19.845 19.227,20.989 L22.914,20.989 L22.914,21.989 L18.628,21.989 C18.506,22.277 18.412,22.58 18.349,22.893 L20.059,22.893 L20.059,23.893 L18.259,23.893 C18.267,24.553 18.41,25.179 18.663,25.749 L20.059,25.749 L20.059,26.749 L19.28,26.749 C20.149,27.855 21.483,28.58 22.996,28.58 C24.509,28.58 25.843,27.855 26.712,26.749 L24.818,26.749 L24.818,25.749 L27.329,25.749 C27.589,25.163 27.739,24.518 27.739,23.836 L27.739,23.836 Z M28.739,23.836 C28.739,27.003 26.163,29.58 22.996,29.58 C19.829,29.58 17.253,27.003 17.253,23.836 C17.253,20.669 19.829,18.093 22.996,18.093 C26.163,18.093 28.739,20.669 28.739,23.836 L28.739,23.836 Z M18.879,18.36 L18.875,18.326 C7.419,19.662 5.874,23.435 5.874,26.951 L6.874,26.951 C6.874,24.008 8.215,20.853 17.688,19.496 C18.036,19.07 18.439,18.692 18.879,18.36 L18.879,18.36 Z M16.82,20.866 C16.646,21.227 16.501,21.606 16.392,21.999 C9.758,23.8 9.748,27.119 9.748,29.825 L8.748,29.825 C8.748,27.011 8.772,22.82 16.82,20.866 L16.82,20.866 Z",
    id: "Amazon-Kinesis-Data-Streams_Icon_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonKinesisDataStreams32);
export default __webpack_public_path__ + "static/media/Arch_Amazon-Kinesis-Data-Streams_32.556f1aafe6897978ac8e39690edb45a2.svg";
export { ForwardRef as ReactComponent };